import * as z from "../../../framework";
import * as ui from "../ui";

var view = () => new ui.Container({
    classes: "mar-t-20",
    components: [
        new ui.Container({
            bsc: "col-xs-12",
            childBsc: "col-xs-12",
            components: [
                new ui.DropDownList({
                    id: "Language",
                    label: "Language",
                    dataTextField: "CodeNumber",
                    dataValueField: "CodeNumber",
                    dataSource: $.grep(z.codes.Culture, function (data) { return data.Id != -1 && data.CodeNumber != "en-qt"; }),
                    required: true
                })
            ]
        })
    ]
});

export default view;
